import React, { useState } from 'react';
import Modal from 'react-modal';
import ListItem from 'grommet/components/ListItem';
import Icons from '../../../../../components/UI/Icons/Icons';
import TrainersAddEditTrainer from '../TrainersAddEditTrainer/TrainersAddEditTrainer';
import classes from './SingleTrainer.module.scss';
import { isFullAccessAdminOrTrainer } from '../../../../../shared/userFunctions';
import { useMutation } from 'react-query';
import { deleteAdmin } from '../../../../../apiFunctions/apiFunctions';
import CustomToast from '../../../../../components/CustomToast/CustomToast';
import withAdminDashboard from '../../../../../store/hoc/withAdminDashboard';

const SingleTrainer = ({ singleTrainer, refreshData }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [toast, setToast] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const mutateDeleteTrainer = useMutation(() => deleteAdmin(singleTrainer._id), {
    onSuccess: () => {
      setToast({
        status: 'ok',
        msg: 'Successfully deleted',
        show: true
      });
      refreshData();
    },
    onError: (response) => {
      setShowModal(false);
      setToast({
        status: 'critical',
        msg: response.data.message ? response.data.message : 'Something went wrong, try again',
        show: true
      });
    }
  });
  const handleTrainerDelete = () => {
    if (!showConfirm) {
      setToast({
        status: 'warning',
        msg: 'Click once again to confirm the deletion of the trainer in all gyms',
        show: true
      });
      return setShowConfirm(true);
    }
    mutateDeleteTrainer.mutate();
  };

  const handleOpenModal = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);

  return (
    <div>
      <CustomToast toast={toast} />
      <Modal
        onRequestClose={handleModalClose}
        isOpen={showModal}
        className="ss-modal ss-modal--auto"
        ariaHideApp={false}>
        <div className="grommet" style={{ padding: '0 10px' }}>
          <TrainersAddEditTrainer editTrainer={singleTrainer} closeModal={handleModalClose} refreshData={refreshData} />
        </div>
      </Modal>

      <ListItem direction="column" align="start" separator="horizontal">
        <div className={classes.singleTrainer}>
          <div className={classes.trainerName}>
            <div>
              {singleTrainer.name} {singleTrainer.last_name}
            </div>
            {isFullAccessAdminOrTrainer(singleTrainer) && <div>Full access</div>}
          </div>

          <Icons edit delete editClick={handleOpenModal} deleteClick={handleTrainerDelete} />
        </div>
      </ListItem>
    </div>
  );
};

export default withAdminDashboard(SingleTrainer);
